import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { HeadersPath, path } from '../../Utils/ScreenPath';
import { User, FileQuestion, ShoppingBag, ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom';
import { getlocalStorage, handleLogout, setlocalStorage, setToken } from '../../Service/api/configuration/localstorage';
import logout from '../../assets/images/logout.png';

const Profile = ({
    name = "John Doe",
    email = "2H2oC@example.com",
    avatarUrl = "https://i.ibb.co/2Z7yX2z/Profile.png",
    onPersonalInfoClick,
    onReportedQuestionsClick,
    onPurchaseHistoryClick
}) => {
    const dispatch = useDispatch();
    const userData = getlocalStorage("userData");
    const navigate = useNavigate();
    const GetUser = useSelector((state) => state?.GetUser?.GetUserData || {});


    useEffect(() => {
        if (GetUser?.status === 200) {
            setlocalStorage("userData", GetUser?.data?.userInfo)
        }
    }, [GetUser])

    useEffect(() => {
        let params = {
            id: userData?.user_id
        }
        dispatch(ACTIONS.GetUserAction(params))
        dispatch(ACTIONS.getHeaderPath(HeadersPath.Profile))
    }, [])

    return (
        <>
            <div className="bg-white shadow-md rounded-lg  mx-auto">
                <div className="flex items-center my-8 p-4">
                    <img src={GetUser?.data?.userInfo?.image} alt={name} className="w-16 h-16 rounded-full mr-4" />
                    <div>
                        <h2 className="text-xl font-semibold">{GetUser?.data?.userInfo?.first_name}</h2>
                        <p className="text-gray-600 text-sm">{GetUser?.data?.userInfo?.email}</p>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <button
                    onClick={() => navigate(path.ProfileInformation)}
                    className="w-full flex items-center justify-between bg-white hover:bg-gray-200 p-4 font-semibold rounded-lg transition duration-200"
                >
                    <div className="flex items-center">
                        <User className="w-6 h-6 mr-3 text-purple-600" />
                        <span>Personal Information</span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                </button>
                <button
                    onClick={() => navigate(path.QuestionReport)}
                    className="w-full flex items-center justify-between bg-white hover:bg-gray-200 p-4 font-semibold  rounded-lg transition duration-200"
                >
                    <div className="flex items-center">
                        <FileQuestion className="w-6 h-6 mr-3 text-pink-600" />
                        <span>Reported Questions</span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                </button>
                <button
                    onClick={() => navigate(path.ReportedQuestions)}
                    className="w-full flex items-center justify-between bg-white hover:bg-gray-200 p-4 font-semibold  rounded-lg transition duration-200"
                >
                    <div className="flex items-center">
                        <ShoppingBag className="w-6 h-6 mr-3 text-orange-600" />
                        <span>Purchase Subject History</span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                </button>
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center justify-between bg-white hover:bg-gray-200 p-4 font-semibold  rounded-lg transition duration-200"
                >
                    <div className="flex items-center">
                        <img src={logout} alt={name} className="w-6 h-6 mr-3"></img>
                        <span>Log Out</span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                </button>
            </div>
        </>
    )
}

export default Profile